var map = {
	"./bird10.svg": 8771,
	"./bird11.svg": 5349,
	"./bird12.svg": 9648,
	"./bird13.svg": 3565,
	"./bird14.svg": 1013,
	"./bird15.svg": 7464,
	"./bird2.svg": 2885,
	"./bird3.svg": 8915,
	"./bird4.svg": 3211,
	"./bird5.svg": 1557,
	"./bird6.svg": 5361,
	"./bird7.svg": 8010,
	"./bird8.svg": 1567,
	"./bird9.svg": 577,
	"./birds_on_a_wire1.svg": 1443,
	"./birds_on_a_wire15.svg": 42
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6098;